/**
 * @generated SignedSource<<b6b41fa404fdb94b5458de69829521ee>>
 * @relayHash ed0c903c62f6ecb11e9c5bd81da03229
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/568.0.0-2026-07-14T15:45:41.733Z/useAddItemToCart_userCartItemAddMutation

import { ConcreteRequest } from 'relay-runtime';
export type CartType = "CHECKOUT" | "SAVE_FOR_LATER" | "%future added value";
export type UserCartItemAddOrUpdateInput = {
  clientMutationId?: string | null;
  itemId: string;
  quantity: number;
  skuId: string;
  type: CartType;
};
export type useAddItemToCart_userCartItemAddMutation$variables = {
  input: UserCartItemAddOrUpdateInput;
};
export type useAddItemToCart_userCartItemAddMutation$data = {
  readonly userCartItemAddOrUpdate: {
    readonly cartItem: {
      readonly skuId: string | null;
    } | null;
  } | null;
};
export type useAddItemToCart_userCartItemAddMutation = {
  response: useAddItemToCart_userCartItemAddMutation$data;
  variables: useAddItemToCart_userCartItemAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAddItemToCart_userCartItemAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UserCartItemAddOrUpdatePayload",
        "kind": "LinkedField",
        "name": "userCartItemAddOrUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CartItem",
            "kind": "LinkedField",
            "name": "cartItem",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAddItemToCart_userCartItemAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UserCartItemAddOrUpdatePayload",
        "kind": "LinkedField",
        "name": "userCartItemAddOrUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CartItem",
            "kind": "LinkedField",
            "name": "cartItem",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/568.0.0-2026-07-14T15:45:41.733Z/useAddItemToCart_userCartItemAddMutation",
    "metadata": {},
    "name": "useAddItemToCart_userCartItemAddMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a8050528e8a5191157a1d65fcba88e30";

export default node;
